import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';
import { CompanyNameType } from 'src/app/models/company.model';
import { CompanyService } from 'src/app/state-services/company.service';
import { UserService } from 'src/app/state-services/user.service';

export const userCompanyResolver: ResolveFn<CompanyNameType[]> = () => {
  const userService = inject(UserService);
  const companyService = inject(CompanyService);

  return userService.getProfile().pipe(
    switchMap((profile) => {
      const companyId = profile.companyId?.trim();
      if (!companyId) {
        return of([]);
      }

      const companyName = profile.companyName?.trim();
      if (companyName) {
        return of([{ id: companyId, name: companyName }]);
      }

      return companyService.getCompany(companyId).pipe(
        map((company) => [{ id: company.id, name: company.name }]),
        catchError(() => of([{ id: companyId, name: companyId }])),
      );
    }),
    catchError(() => of([])),
  );
};
